import { Injectable } from '@angular/core';
import { ActionSheetController } from 'ionic-angular';


const shareTitle = 'Arznei+Haut - Medikamente und Nebenwirkungen von A bis Z';
const shareBody = 'Diese App hilft mir bei der Arbeit. Vielleicht ist sie auch was für dich?';

/*
Generated class for the ShareProvider provider.

See https://angular.io/guide/dependency-injection for more info on providers
and Angular DI.
*/
@Injectable()
export class ShareProvider {

  constructor(private actionSheetCtrl: ActionSheetController) {

  }

  share() {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Weitersagen',
      buttons: [
        {
          text: 'E-Mail',
          icon: 'mail',
          handler: () => {
            window.location.href = `mailto:?subject=${shareTitle}&body=${encodeURIComponent(shareBody)}%0A${encodeURIComponent(location.href)}`;
          }
        },{
          text: 'WhatsApp',
          icon: 'logo-whatsapp',
          handler: () => {
            window.location.href = `whatsapp://send?text=${shareBody}%0A${location.href}`;
          }
        },{
          text: 'Facebook',
          icon: 'logo-facebook',
          handler: () => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${location.href}&description=${shareBody}`, '_blank');
          }
        },{
          text: 'Abbrechen',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/share/share.ts